// src/pages/PrivacyPolicy.js

import React from "react";

export default function Privacy() {
  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "0 auto",
        padding: "40px 20px",
        lineHeight: 1.7,
      }}
    >
      <h1>Privacy Policy</h1>

      <p>
        <strong>Last Updated:</strong> June 7, 2026
      </p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to [COMPANY NAME] ("Company", "we", "our", or "us").
        This Privacy Policy explains how we collect, use, disclose,
        and protect information when you use our website, software,
        applications, and services (collectively, the "Services").
      </p>

      <h2>2. Information We Collect</h2>

      <h3>Account Information</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Encrypted password credentials</li>
        <li>Authentication and security information</li>
      </ul>

      <h3>Business Information</h3>
      <ul>
        <li>Business name</li>
        <li>Industry information</li>
        <li>Website URL</li>
        <li>Business descriptions</li>
        <li>Products and services information</li>
      </ul>

      <h3>Lead & Campaign Data</h3>
      <ul>
        <li>Lead names</li>
        <li>Job titles</li>
        <li>Company information</li>
        <li>Email addresses</li>
        <li>Outreach campaign data</li>
        <li>Campaign analytics and performance metrics</li>
      </ul>

      <h3>Payment Information</h3>
      <p>
        Payment transactions are processed through Stripe. We do not
        store full payment card information on our servers.
      </p>

      <h3>Usage Data</h3>
      <ul>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device information</li>
        <li>Pages visited</li>
        <li>Feature usage</li>
        <li>Session information</li>
      </ul>

      <h2>3. How We Use Information</h2>

      <p>We may use information to:</p>

      <ul>
        <li>Provide and maintain our Services</li>
        <li>Create and manage user accounts</li>
        <li>Authenticate users</li>
        <li>Enable multi-factor authentication</li>
        <li>Generate leads and prospecting results</li>
        <li>Create marketing and outreach campaigns</li>
        <li>Provide AI-generated content and recommendations</li>
        <li>Process payments and subscriptions</li>
        <li>Respond to support requests</li>
        <li>Improve platform performance and security</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2>4. Third-Party Services</h2>

      <p>
        To provide our Services, we may share data with trusted
        third-party service providers including:
      </p>

      <ul>
        <li>Supabase (authentication and database services)</li>
        <li>Stripe (payment processing)</li>
        <li>Anthropic (AI content generation)</li>
        <li>Apollo.io (lead discovery services)</li>
        <li>Hunter.io (email discovery services)</li>
        <li>Instantly (email outreach services)</li>
        <li>Resend (email delivery services)</li>
      </ul>

      <p>
        These providers maintain their own privacy policies and data
        protection practices.
      </p>

      <h2>5. AI-Generated Content</h2>

      <p>
        Our platform may use artificial intelligence technologies to
        generate recommendations, marketing content, lead targeting
        suggestions, and outreach materials.
      </p>

      <p>
        AI-generated outputs may not always be accurate, complete,
        or suitable for every use case. Users remain responsible for
        reviewing generated content before use.
      </p>

      <h2>6. Lead Data & Outreach Compliance</h2>

      <p>
        Users are solely responsible for ensuring that their use of
        lead information, prospecting activities, and outreach
        campaigns complies with all applicable laws, regulations,
        and industry standards.
      </p>

      <p>Including but not limited to:</p>

      <ul>
        <li>CAN-SPAM Act</li>
        <li>GDPR</li>
        <li>CCPA</li>
        <li>CASL</li>
        <li>Other applicable privacy regulations</li>
      </ul>

      <h2>7. Cookies & Tracking Technologies</h2>

      <p>
        We may use cookies, session identifiers, and similar
        technologies to:
      </p>

      <ul>
        <li>Maintain user sessions</li>
        <li>Remember preferences</li>
        <li>Analyze platform usage</li>
        <li>Improve security</li>
        <li>Detect abuse and fraud</li>
      </ul>

      <h2>8. Data Retention</h2>

      <p>
        We retain information only for as long as reasonably
        necessary to provide Services, comply with legal
        obligations, resolve disputes, and enforce agreements.
      </p>

      <h2>9. Data Security</h2>

      <p>
        We implement commercially reasonable technical,
        administrative, and organizational safeguards designed to
        protect personal information from unauthorized access,
        disclosure, alteration, or destruction.
      </p>

      <p>
        However, no method of transmission or storage is completely
        secure, and we cannot guarantee absolute security.
      </p>

      <h2>10. International Data Transfers</h2>

      <p>
        Your information may be processed and stored in countries
        outside your country of residence where data protection laws
        may differ.
      </p>

      <h2>11. Your Rights</h2>

      <p>
        Depending on your location and applicable laws, you may have
        rights including:
      </p>

      <ul>
        <li>Access your information</li>
        <li>Correct inaccurate information</li>
        <li>Delete your information</li>
        <li>Restrict processing</li>
        <li>Object to processing</li>
        <li>Request data portability</li>
      </ul>

      <h2>12. Children's Privacy</h2>

      <p>
        Our Services are not intended for individuals under the age
        of 18. We do not knowingly collect personal information from
        minors.
      </p>

      <h2>13. Changes to This Policy</h2>

      <p>
        We may update this Privacy Policy from time to time. Any
        changes will be posted on this page with an updated revision
        date.
      </p>

      <h2>14. Contact Us</h2>

      <p>
        If you have questions regarding this Privacy Policy, please
        contact:
      </p>

      <p>
        <strong>[COMPANY NAME]</strong>
        <br />
        Email: [YOUR SUPPORT EMAIL]
        <br />
        Website: [YOUR WEBSITE]
      </p>
    </div>
  );
}
